import {connect} from "react-redux";
import OpportunityNewActivity from './newActivity'
import {bindActionCreators} from "redux";
import {newActivity} from "../../../../service/Activity/action";
import {getActivity} from "../../../../service/Account/action";
import {documentUploadUrlPublic} from "../../../../service/fileUpload/action";

const mapStateToProps = (state) => ({
    saveNewActivity:state.Activity.saveNewActivity,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    accountActivity:state.Dropdown.accountActivity,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            newActivity,
            getActivity
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(OpportunityNewActivity);
